import { usePathname } from 'next/navigation';

export const useIsShop = (): boolean => {
  const pathname = usePathname();
  return pathname?.startsWith('/shop/') || pathname === '/shop';
};
